(function () {
  function loadHighResImage(image) {
    const source = image.currentSrc || image.src;
    if (!source) return;

    const highResSource = source.replace(/([?&])width=\d+/i, '$1width=1600');
    image.loading = 'eager';

    if (highResSource !== source) {
      image.srcset = '';
      image.sizes = '';
      image.src = highResSource;
      return;
    }

    if (!image.complete && image.currentSrc) {
      image.src = image.currentSrc;
    }
  }

  function initBackCoverLightbox() {
    document.querySelectorAll('[data-paya-back-cover-open]').forEach((trigger) => {
      const dialogId = trigger.getAttribute('aria-controls');
      const dialog = dialogId ? document.getElementById(dialogId) : null;
      if (!dialog || !(dialog instanceof HTMLDialogElement)) return;

      trigger.addEventListener('click', () => {
        if (typeof dialog.showModal !== 'function') return;

        dialog.showModal();

        const image = dialog.querySelector('.product-book__cover-dialog-image');
        if (image instanceof HTMLImageElement) {
          if (image.complete) {
            loadHighResImage(image);
          } else {
            image.addEventListener('load', () => loadHighResImage(image), { once: true });
          }
        }
      });

      dialog.querySelectorAll('[data-paya-back-cover-close]').forEach((closeButton) => {
        closeButton.addEventListener('click', () => dialog.close());
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
          dialog.close();
        }
      });

      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        dialog.close();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBackCoverLightbox);
  } else {
    initBackCoverLightbox();
  }
})();
